import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';



import { inject, observer } from 'mobx-react';
import { Provider as KeepAliveProvider } from 'react-keep-alive';

import './App.css';
import Routes from "./router";

import Loading from '@components/Loading/';
import Drawer from '@components/Drawer/';
import { AppStore } from '@store/';


@inject(stores => ({
    appStore: stores.appStore,
}))
@observer
class App extends Component {
    componentDidMount() {
        let path = window.location.pathname;
        if (path !== '/' && path !== '/map') {
            this.props.appStore.firstPageIsOk();
        }
        this.props.history.listen((location, action) => {
            window._hmt.push(['_trackPageview', location.pathname]);
        });
    }

    openMenu() {
        _hmt.push(["_trackEvent", "nav", "openMenu", "MainMenu"]);
    }

    render() {
        return (
            <>
                <Loading />
                <Drawer />
                <KeepAliveProvider>
                    <main>
                        <div className="mdui-progress" id="progress">
                            <div className="mdui-progress-indeterminate"></div>
                        </div>
                        <button className="mdui-btn mdui-btn-icon" id="appBtn" mdui-drawer="{target: '#drawer'}" onClick={this.openMenu}>
                            <i className="mdui-icon material-icons">menu</i>
                        </button>
                        <Routes />
                    </main>
                </KeepAliveProvider>
            </>
        );
    }
}
App.wrappedComponent.propTypes = {
    appStore: PropTypes.instanceOf(AppStore).isRequired,
    history: PropTypes.object.isRequired,
};

export default withRouter(App);
